import { Ref, ref } from "vue";

interface UseCurrentLocationMarker {
  currentLocationMarker: Ref<any>;
  createCurrentLocationMarker: (
    map: any,
    latitude?: number,
    longitude?: number
  ) => void;
  removeCurrentLocationMarker: () => void;
}

export const useCurrentLocationMarker = (
  createMarker: (
    lat: number,
    lng: number,
    markerImage: () => any,
    zIndex: number
  ) => any
): UseCurrentLocationMarker => {
  const currentLocationMarker = ref<any>();

  const getCurrentLocationContentHtml = () => {
    const primary = getComputedStyle(document.documentElement).getPropertyValue(
      "--primary"
    );
    const primaryAlpha20 = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--primary-alpha20");

    return `
    <div style="
      padding: 11px;
      background-color: ${primaryAlpha20};
      border-radius: 50px;"
    >
      <div style="
        width: 9px;
        height: 9px;
        border: 2px solid #fff;
        background-color: ${primary};
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
        border-radius: 50px;"
      ></div>
    </div>`;
  };

  const getCurrentLocationMarkerImage = () => {
    return {
      content: getCurrentLocationContentHtml(),
      size: new window.naver.maps.Size(20, 32),
      origin: new window.naver.maps.Point(0, 0),
      anchor: new window.naver.maps.Point(10, 16),
    };
  };

  const createCurrentLocationMarker = (
    map: any,
    latitude?: number,
    longitude?: number
  ) => {
    if (!latitude || !longitude) return;

    currentLocationMarker.value = createMarker(
      latitude,
      longitude,
      getCurrentLocationMarkerImage,
      200
    );
    currentLocationMarker.value.setMap(map);
  };

  const removeCurrentLocationMarker = () => {
    currentLocationMarker.value.setMap(null);
  };

  return {
    currentLocationMarker,
    createCurrentLocationMarker,
    removeCurrentLocationMarker,
  };
};
